import { LOZENGE_HEIGHT, LOZENGE_SPACING } from '../settings/Global';

export default function getLozengeHeight(numRows = 1): number {
    return LOZENGE_HEIGHT * numRows + LOZENGE_SPACING * (numRows - 1);
}
